export default {
  Treasury: 1,
  Bank: 2,
};
